module.exports = __webpack_public_path__ + "static/media/about-feira.29666a11.jpg";